var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ufi-card primaryFont"},[_c('h3',{staticClass:"title",style:({ fontSize: _vm.titleSize })},[_vm._v(_vm._s(_vm.title))]),_c('apexchart',{attrs:{"type":"radialBar","height":"300","options":_setup.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }